import { render, staticRenderFns } from "./AddonsFormBreakdown.vue?vue&type=template&id=225fd388&scoped=true&"
import script from "./AddonsFormBreakdown.vue?vue&type=script&lang=js&"
export * from "./AddonsFormBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./AddonsFormBreakdown.vue?vue&type=style&index=0&id=225fd388&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225fd388",
  null
  
)

export default component.exports